import { observable, action } from 'mobx'
import axios from "axios/index";
import gql from "../utils/gql";
import _ from "underscore";
import {reactLocalStorage as Storage} from "reactjs-localstorage";
import {Common as util} from "../utils/common";
// import GoodsList from "../containers/pages/goods/goodsList";

//https://fontawesomeicons.com/materialdesign/icons

const originAxiosInstance = axios.create({
  // orpapi-base.onreview.co.kr 은 같은 서버(동일 IP)지만 SSL 인증서가 orpapi.onreview.co.kr 만 커버하여
  // 프로덕션에서 ERR_CERT_COMMON_NAME_INVALID 발생 → 환경 구분 없이 정상 인증서 도메인 사용
  baseURL: 'https://orpapi.onreview.co.kr'
});

export class Common {

  @observable curNavInfo = {};
  @observable category = [];
  @observable orgCategory = [];
  @observable isShowModal = false;
  @observable favorites = [];

  // 즐겨찾기 0개일 때 노출되는 기본 메뉴
  DEFAULT_FAVORITES = [
    {label: '리뷰 리스트',     to: '/reviewList',        mIcon: 'library_books'},
    {label: '리뷰 작성',       to: '/reviewWrite',       mIcon: 'rate_review'},
    {label: '리뷰 대량 등록',  to: '/reviewMassWrite',   mIcon: 'note_add'},
    {label: '설정',            to: '/reviewWriteConfig', mIcon: 'mode_edit'},
    {label: '설치&연동',       to: '/easySetting',       mIcon: 'settings_suggest'},
    {label: '페이지별 위젯',   to: '/widgetByPage',      mIcon: 'web'}
  ];

  constructor() {
    this.loadFavorites();
  }

  @action loadFavorites = () => {
    try {
      const stored = Storage.get('menu_favorites');
      const parsed = stored ? JSON.parse(stored) : null;
      if (Array.isArray(parsed) && parsed.length > 0) {
        this.favorites = parsed;
      } else {
        // 0개일 때 기본 셋팅 적용 (저장은 하지 않음 — 사용자가 직접 토글하면 그때 저장)
        this.favorites = this.DEFAULT_FAVORITES.slice();
      }
    } catch (e) {
      this.favorites = this.DEFAULT_FAVORITES.slice();
    }
  };

  @action toggleFavorite = (menuItem) => {
    const idx = this.favorites.findIndex(f => f.to === menuItem.to);
    if (idx > -1) {
      this.favorites.splice(idx, 1);
    } else {
      this.favorites.push({ label: menuItem.label, to: menuItem.to, mIcon: menuItem.mIcon });
    }
    Storage.set('menu_favorites', JSON.stringify(this.favorites));
  };

  @action reorderFavorites = (fromIndex, toIndex) => {
    if (fromIndex === toIndex) return;
    if (fromIndex < 0 || fromIndex >= this.favorites.length) return;
    if (toIndex < 0 || toIndex >= this.favorites.length) return;
    const next = this.favorites.slice();
    const [moved] = next.splice(fromIndex, 1);
    next.splice(toIndex, 0, moved);
    this.favorites = next;
    Storage.set('menu_favorites', JSON.stringify(this.favorites));
  };

  isFavorite = (path) => {
    return this.favorites.some(f => f.to === path);
  };

  // src/routes.js의 name값 참고
  @observable navItems = [
    {
      label: "리뷰/답글",
      mIcon: 'playlist_add_check',
      name: "review",
      to: "/reviewList",
      submenu: [
        {label: "리뷰 리스트", to: "/reviewList",  name: "reviewList", mIcon: 'library_books'},
        {label: "리뷰 설정", to: "/reviewWriteConfig",  name: "reviewWriteConfig", mIcon: 'mode_edit'},
        {label: "간편 리뷰 설정", to: "/quickReviewConfig",  name: "quickReviewConfig", mIcon: 'touch_app'},
        {label: "설문 리뷰 설정", to: "/surveyReviewConfig",  name: "surveyReviewConfig", mIcon: 'quiz'},
        {label: "SNS Feed(Beta)", to: "/snsFeed",  name: "snsFeed", mIcon: 'share'},
        {label: "상품별 리뷰 작성 설정", to: "/reviewWriteConfigByProduct",  name: "reviewWriteConfigByProduct", mIcon: 'edit_note'},
        {label: "활용 가이드", to: "/reviewGuide",  name: "reviewGuide", mIcon: 'auto_stories', isShowSuperAdmin: true}
      ]
    },
    {
      label: "리뷰 위젯",
      mIcon: 'app_registration',
      name: "widget",
      to: "/widgetList",
      submenu: [
        {label: "페이지별 위젯", to: "/widgetByPage", name: "widgetByPage", mIcon: 'web'},
        {label: "그리드 위젯", to: "/widgetList",  name: "widgetList", mIcon: 'art_track'},
        {label: "숏폼위젯", to: "/shortFormWidget",  name: "shortFormWidget", mIcon: 'smart_display'},
        {label: "언어/라벨 설정", to: "/labeling",  name: "labeling", mIcon: 'language'},
        {label: "AI 상품 위젯", to: "/productWidgetList",  name: "productWidgetList", mIcon: 'category', isShowSuperAdmin: true},
        {label: "AI 토탈 위젯", to: "/totalAiWidget",  name: "totalAiWidget", mIcon: 'category', isShowSuperAdmin: true}
      ]
    },
    {
      label: "리뷰 부스터",
      mIcon: 'edit_note',
      name: "reviewWriteGroup",
      to: "/reviewWrite",
      submenu: [
        {label: "리뷰 작성", to: "/reviewWrite",  name: "reviewWrite", mIcon: 'rate_review'},
        {label: "리뷰 대량 등록", to: "/reviewMassWrite",  name: "reviewMassWrite", mIcon: 'note_add'},
        {label: "상품 리뷰 복사", to: "/reviewCopy",  name: "reviewCopy", mIcon: 'content_copy'},
        {label: "리뷰(상품) 그룹화", to: "/reviewGroup",  name: "reviewGroup", mIcon: 'group_work'}
      ]
    },
    {
      label: "작성유도(알림톡)",
      mIcon: 'trending_up',
      name: "booster",
      to: "/kakaoMsgSetting",
      submenu: [
        {label: "알림톡 설정", to: "/kakaoMsgSetting",  name: "kakaoMsgSetting", mIcon: 'assignment'},
        {label: "알림톡 내역", to: "/msgList",  name: "msgList", mIcon: 'phonelink_setup'},
        {label: "작성알림위젯", to: "/reviewableListWidget", name: "reviewableListWidget", mIcon: 'fact_check'},
      ]
    },
    {
      label: "주문유도",
      mIcon: 'shopping_cart_checkout',
      name: "orderBooster",
      to: "/integratedMessage",
      submenu: [
        {label: "통합메시지", to: "/integratedMessage", name: "integratedMessage", mIcon: 'forum', isShowSuperAdmin: true},
        {label: "인기 제품 분석", to: "/popularProducts", name: "popularProducts", mIcon: 'leaderboard', isShowSuperAdmin: true},
        {label: "메인 상품 진열", to: "/mainDisplay", name: "mainDisplay", mIcon: 'storefront', isShowSuperAdmin: true},
        {label: "인기상품 메인진열", to: "/popularDisplay", name: "popularDisplay", mIcon: 'auto_awesome', isShowSuperAdmin: true},
        {label: "무료배송 위젯", to: "/freeShippingWidget", name: "freeShippingWidget", mIcon: 'local_shipping'},
      ]
    },
    {
      label: "모니터",
      mIcon: 'monitor_heart',
      name: "monitor",
      to: "/dashboard",
      submenu: [
        {label: "대시보드", to: "/dashboard", name: "dashboard", mIcon: 'dashboard'},
        {label: "행동 분석", to: "/widgetAnalytics", name: "widgetAnalytics", mIcon: 'insights', isShowSuperAdmin: true}
      ]
    },
    {
      label: "설정",
      mIcon: 'settings',
      name: "settings",
      to: "/reviewWriteConfig",
      submenu: [
        {label: "설치&연동", to: "/easySetting", name: "easySetting", mIcon: 'settings_suggest'},
        {label: "마일리지 지급 관리", to: "/reviewMileage",  name: "reviewMileage", mIcon: 'real_estate_agent'},
        {label: "마일리지 지급 설정", to: "/mileageConfig",  name: "mileageConfig", mIcon: 'local_parking'},
        {label: "리뷰 답글 설정", to: "/replyWriteConfig",  name: "replyWriteConfig", mIcon: 'question_answer'},
        {label: "상품별 답글 설정", to: "/replyByProductList",  name: "replyByProductList", mIcon: 'category'},
        {label: "리뷰 필터링", to: "/reviewFilter",  name: "reviewFilter", mIcon: 'auto_awesome'},
        {label: "SNS 연동(Beta)", to: "/snsSetting",  name: "snsSetting", mIcon: 'share'},
        {label: "관리자 정보", to: "/teamUserInfo",  name: "teamUserInfo", mIcon: 'person'},
        {label: "회사 정보", to: "/companyInfo",  name: "companyInfo", mIcon: 'store'},
      ]
    },
    {
      label: "디자인 관리",
      mIcon: 'design_services',
      name: "design",
      to: "/banner",
      submenu: [
        {label: "배너 관리", to: "/banner",  name: "banner", mIcon: 'view_agenda', isShowSuperAdmin: true},
        {label: "팝업 관리", to: "/popup",  name: "popup", mIcon: 'campaign'},
        {label: "리뷰 → 인스타 이미지", to: "/reviewToInsta",  name: "reviewToInsta", mIcon: 'photo_camera'},
        {label: "리뷰 → 영상", to: "/reviewToVideo",  name: "reviewToVideo", mIcon: 'movie'},
        {label: "이미지 배경제거", to: "/bgRemover",  name: "bgRemover", mIcon: 'auto_fix_high'},
        {label: "내 이미지 관리", to: "/myImages",  name: "myImages", mIcon: 'photo_library'}
      ]
    },
    {
      label: "블로그",
      mIcon: 'article',
      name: "blog",
      to: "/blogList",
      submenu: [
        {label: "리스트", to: "/blogList",  name: "blogList", mIcon: 'view_list'},
        {label: "설정", to: "/blogConfig",  name: "blogConfig", mIcon: 'settings'}
      ],
      isShowSuperAdmin: true
    },
    {
      label: "SEO",
      mIcon: 'search',
      name: "seo",
      to: "/seoAudit",
      submenu: [
        {label: "기본 진단/설정", to: "/seoAudit",  name: "seoAudit", mIcon: 'search'},
        {label: "상품별 설정", to: "/seoProductList",  name: "seoProductList", mIcon: 'inventory_2'},
      ]
    },
    {
      label: "결제",
      mIcon: 'payment',
      name: "payment",
      to: "/inAppOrder",
      submenu: [
        {label: "결제", to: "/inAppOrder",  name: "inAppOrder", mIcon: 'payment'},
        {label: "결제 내역", to: "/inAppOrderList",  name: "inAppOrderList", mIcon: 'receipt'},
        {label: "알림톡 결제", to: "/msgOrder",  name: "msgOrder", mIcon: 'payment'},
        {label: "알림톡 결제 내역", to: "/msgOrderList",  name: "msgOrderList", mIcon: 'receipt'},
      ]
    },
    {
      label: "설치/문의",
      mIcon: 'article',
      name: "board",
      to: "/installationRequest",
      submenu: [
        {label: "설치 요청", to: "/installationRequest",  name: "installationRequest", mIcon: 'electrical_services'},
        {label: "문의하기", to: "/inquiry", name: "inquiry", mIcon: 'help'},
        {label: "내 문의", to: "/myBoard", name: "myBoard", mIcon: 'contact_support'},
        {label: "QnA", to: "/qna", name: "qna", mIcon: 'quiz', isShowSuperAdmin: true}
      ]
    },
    {
      label: "스토어 관리",
      mIcon: 'business',
      isShowSuperAdmin: true,
      name: "aoa",
      to: "/allStoreList",
      submenu: [
        {label: "전체 스토어", to: "/allStoreList",  name: "allStoreList", mIcon: 'domain'},
        {label: "샵 리스트", to: "/shopList",  name: "shopList", mIcon: 'store'},
        {label: "설치 신청", to: "/installationRequests", name: "installationRequests", mIcon: 'electrical_services'},
        {label: "문의 답변", to: "/inquiryList", name: "inquiryList", mIcon: 'question_answer'},
        {label: "QnA 관리", to: "/qnaList", name: "qnaList", mIcon: 'quiz'},
        {label: "알림 발송", to: "/notificationSend",  name: "notificationSend", mIcon: 'campaign'},
        {label: "문자 직접 발송", to: "/aligoSmsSend",  name: "aligoSmsSend", mIcon: 'sms'},
        {label: "전체 스토어 결제 내역", to: "/storeOrderList",  name: "storeOrderList", mIcon: 'receipt_long'},
        {label: "알림톡 결제", to: "/storeMsgOrderList",  name: "storeMsgOrderList", mIcon: 'store'},
        {label: "팝업 설정", to: "/loginNoticePopup",  name: "loginNoticePopup", mIcon: 'campaign'},
        {label: "요금제 플랜 관리", to: "/superConfigPayment",  name: "superConfigPayment", mIcon: 'payments'},
        {label: "메일 발송 내역", to: "/emailHistoryList", name: "emailHistoryList", mIcon: 'email'},
        {label: "통장입금 처리 내역", to: "/bankTransferList", name: "bankTransferList", mIcon: 'account_balance'},
        {label: "샵 마일리지", to: "/shopMileage", name: "shopMileage", mIcon: 'savings'}
          //리뷰 리스트, 주문 리스트
      ]
    },
    {
      label: "스토어 모니터/분석",
      mIcon: 'insights',
      isShowSuperAdmin: true,
      name: "aoaMonitor",
      to: "/adminMonitor",
      submenu: [
        {label: "통합 모니터", to: "/adminMonitor",  name: "adminMonitor", mIcon: 'monitor_heart'},
        {label: "관리자 사용 분석", to: "/adminUsageDashboard",  name: "adminUsageDashboard", mIcon: 'analytics'},
        {label: "주문/리뷰 패턴", to: "/orderReviewPattern",  name: "orderReviewPattern", mIcon: 'grid_on'},
        {label: "Webhook 모니터", to: "/webhookDashboard",  name: "webhookDashboard", mIcon: 'webhook'},
        {label: "AI 키워드 검증", to: "/aiKeywordList",  name: "aiKeywordList", mIcon: 'psychology'},
        {label: "스토어 처리", to: "/storeFnList",  name: "storeFnList", mIcon: 'store'},
        {label: "스토어 데이터", to: "/storeDataCounts",  name: "storeDataCounts", mIcon: 'database'},
        {label: "데이터 마이그레이션", to: "/dataMigration", name: "dataMigration", mIcon: 'sync_alt'},
        {label: "분석 리포트", to: "/analysisReport", name: "analysisReport", mIcon: 'bar_chart'}
      ]
    }
  ];

  @observable navItemsIndexByName = _.indexBy(this.navItems, 'name');

  @action getCurNav = ( ) => {
    return this.curNavInfo;
  };

  @action setIsShowPopup = (isStatus) => {
    return this.isShowModal = isStatus;
  };

  @action getIsShowPopup = () => {
    return this.isShowModal;
  };




  @action setPageInfo = (route) => {

    let submenuByTo = {};
    let res = {};
    if(this.navItemsIndexByName[route.info.mainMenu].submenu && this.navItemsIndexByName[route.info.mainMenu].submenu[0] && this.navItemsIndexByName[route.info.mainMenu].submenu[0].submenu) {
      for(let index in this.navItemsIndexByName[route.info.mainMenu].submenu) {
        let row = this.navItemsIndexByName[route.info.mainMenu].submenu[index];
        let middleMenu = row.label;
        for(let index in row.submenu) {
          let cRow = row.submenu[index]
          cRow.middleMenu = middleMenu;
          submenuByTo[cRow.to] = cRow;
        }
      }
    }
    else {
      submenuByTo = _.indexBy(this.navItemsIndexByName[route.info.mainMenu].submenu, 'to');
    }
    res.route = route;
    res.mainMenu = route.info.mainMenu;
    res.mainMenu = this.navItemsIndexByName[route.info.mainMenu];
    res.submenu = submenuByTo[route.path];
    this.curNavInfo = res;
  };


  @action getConBoard = ( boardkey ) => {

    let result = Storage.getObject('board_' + boardkey);
    result.boardKeys = Storage.getObject('boardKeys');
    if(result) {
      return result;
    }
    else {
      console.log(result)
    }

  };



  @action getSetting = ( cb ) => {

    let v = Storage.get('v');

    //test
    v = '0.0.0'
    let params = {
      type: 'query',
      operation: 'getSetting',
      variables: { v  : v ? v : '0.0.0' },
      getData: 'data'
    };

    const gpqParams = gql(params);
    axios.post('/', gpqParams)
      .then(function (res) {
        let result = res.data.data[params.operation];
        if(result) {
          if(result.data.v) {
            Storage.set('v', result.data.v);
          }
          if(result.data.ConBoard) {
            let boardKeys = [];
            result = _.indexBy(result.data.ConBoard, 'key')
            for(let key in result) {
              Storage.setObject('board_' + key , result[key]);
              boardKeys.push(key)
            }
            Storage.setObject('boardKeys' , boardKeys);
          }
        }
        else {
          throw res.data.errors;
        }

      })
      .catch(function (error) {
        return error;
      });
  };

  @action getStoreTotalConfig = (data, cb) => {

    let property = ['store_id', 'shopNo']
    let variables = util.getDataStByKey(data, property);

    let params = {
      type: 'query',
      operation: 'getStoreTotalConfig',
      variables: variables,
      getData: 'data'
    };
    const gpqParams = gql(params);

    return axios.post('/', gpqParams)
      .then(function (res) {
        let result = res.data.data[params.operation];
        if(typeof cb === 'function') {
          cb(result.data);
        }
        else {
          return result.data;
        }

      })
      .catch(function (error) {
        if(typeof cb === 'function') {
          cb(error)
        }
        return error;
      });
  };

  // 관리자 로그인 안내 팝업 — 조회
  @action getAdminLoginNotice = (cb) => {
    let params = {
      type: 'query',
      operation: 'getAdminLoginNotice',
      variables: {},
      getData: 'data'
    };
    const gpqParams = gql(params);
    return axios.post('/', gpqParams)
      .then(function(res) {
        const result = res && res.data && res.data.data ? res.data.data[params.operation] : null;
        if (typeof cb === 'function') cb(result && result.data ? result.data : null);
        else return result && result.data ? result.data : null;
      })
      .catch(function(error) {
        if (typeof cb === 'function') cb(null);
        return error;
      });
  };

  // 다중 팝업: 모든 안내 팝업 조회
  @action getAdminLoginNoticeList = (cb) => {
    let params = {
      type: 'query',
      operation: 'getAdminLoginNoticeList',
      variables: {},
      getData: 'data'
    };
    const gpqParams = gql(params);
    return axios.post('/', gpqParams)
      .then(function(res) {
        const result = res && res.data && res.data.data ? res.data.data[params.operation] : null;
        const list = result && Array.isArray(result.data) ? result.data : [];
        if (typeof cb === 'function') cb(list);
        else return list;
      })
      .catch(function(error) {
        if (typeof cb === 'function') cb([]);
        return error;
      });
  };

  // 다중 팝업: 신규/수정 (id 있으면 수정, 없으면 신규)
  @action saveAdminLoginNotice = (data, cb) => {
    if (data && data.content) data.content = util.escapeGraphQLString(data.content);
    if (data && data.title) data.title = util.escapeGraphQLString(data.title);
    let property = ['id','isActive','title','content','backgroundColor','accentColor','startAt','endAt','targetMode','targetStoreKeys','displayPages','showSkipToday'];
    let variables = util.getDataStByKey(data, property);
    let params = {
      type: 'mutation',
      operation: 'saveAdminLoginNotice',
      variables: variables,
      getData: 'data'
    };
    const gpqParams = gql(params);
    return axios.post('/', gpqParams)
      .then(function(res) {
        if (typeof cb === 'function') cb(res.data.data[params.operation]);
        else return res.data.data[params.operation];
      })
      .catch(function(error) {
        if (typeof cb === 'function') cb(error);
        return error;
      });
  };

  @action removeAdminLoginNotice = (id, cb) => {
    let params = {
      type: 'mutation',
      operation: 'removeAdminLoginNotice',
      variables: {id},
      getData: 'data'
    };
    const gpqParams = gql(params);
    return axios.post('/', gpqParams)
      .then(function(res) {
        if (typeof cb === 'function') cb(res.data.data[params.operation]);
        else return res.data.data[params.operation];
      })
      .catch(function(error) {
        if (typeof cb === 'function') cb(error);
        return error;
      });
  };

  // 관리자 로그인 안내 팝업 — 저장(upsert)
  @action updateAdminLoginNotice = (data, cb) => {
    if (data && data.content) data.content = util.escapeGraphQLString(data.content);
    if (data && data.title) data.title = util.escapeGraphQLString(data.title);
    let property = ['isActive','title','content','backgroundColor','accentColor','startAt','endAt','targetMode','targetStoreKeys','displayPages','showSkipToday'];
    let variables = util.getDataStByKey(data, property);
    let params = {
      type: 'mutation',
      operation: 'updateAdminLoginNotice',
      variables: variables,
      getData: 'data'
    };
    const gpqParams = gql(params);
    return axios.post('/', gpqParams)
      .then(function(res) {
        if (typeof cb === 'function') cb(res.data.data[params.operation]);
        else return res.data.data[params.operation];
      })
      .catch(function(error) {
        if (typeof cb === 'function') cb(error);
        return error;
      });
  };

  // 대량 등록 매핑 양식 API
  @action getReviewMappingTemplates = (data, cb) => {
    let params = {
      type: 'query',
      operation: 'getReviewMappingTemplates',
      variables: { store_id: data.store_id },
      getData: 'data'
    };
    const gpqParams = gql(params);
    return axios.post('/', gpqParams)
      .then(function (res) {
        const result = res.data.data[params.operation];
        if (typeof cb === 'function') cb(result);
        else return result;
      })
      .catch(function (error) { console.log(error); return error; });
  };

  @action saveReviewMappingTemplate = (data, cb) => {
    let params = {
      type: 'mutation',
      operation: 'saveReviewMappingTemplate',
      variables: data,
      getData: 'data'
    };
    const gpqParams = gql(params);
    return axios.post('/', gpqParams)
      .then(function (res) {
        const result = res.data.data[params.operation];
        if (typeof cb === 'function') cb(result);
        else return result;
      })
      .catch(function (error) { console.log(error); return error; });
  };

  @action deleteReviewMappingTemplate = (data, cb) => {
    let params = {
      type: 'mutation',
      operation: 'deleteReviewMappingTemplate',
      variables: data,
      getData: 'data'
    };
    const gpqParams = gql(params);
    return axios.post('/', gpqParams)
      .then(function (res) {
        const result = res.data.data[params.operation];
        if (typeof cb === 'function') cb(result);
        else return result;
      })
      .catch(function (error) { console.log(error); return error; });
  };

  // === 내 이미지 관리 ===
  @action getMyImageList = (data, cb) => {
    let property = ['store_id', 'shopNo', 'page', 'limit', 'keyword', 'source'];
    let variables = util.getDataStByKey(data, property);
    let params = {type: 'query', operation: 'getMyImageList', variables, getData: 'data'};
    const gpqParams = gql(params);
    return axios.post('/', gpqParams)
      .then(res => {
        const result = res.data.data[params.operation];
        if (typeof cb === 'function') cb(result); else return result;
      })
      .catch(err => { console.log(err); return err; });
  };

  @action addMyImage = (data, cb) => {
    let property = ['store_id', 'shopNo', 'name', 'url', 'size', 'width', 'height', 'source', 'tags'];
    let variables = util.getDataStByKey(data, property);
    let params = {type: 'mutation', operation: 'addMyImage', variables, getData: 'data'};
    const gpqParams = gql(params);
    return axios.post('/', gpqParams)
      .then(res => {
        const result = res.data.data[params.operation];
        if (typeof cb === 'function') cb(result); else return result;
      })
      .catch(err => { console.log(err); return err; });
  };

  @action updateMyImage = (data, cb) => {
    let property = ['id', 'store_id', 'name', 'tags'];
    let variables = util.getDataStByKey(data, property);
    let params = {type: 'mutation', operation: 'updateMyImage', variables, getData: 'data'};
    const gpqParams = gql(params);
    return axios.post('/', gpqParams)
      .then(res => {
        const result = res.data.data[params.operation];
        if (typeof cb === 'function') cb(result); else return result;
      })
      .catch(err => { console.log(err); return err; });
  };

  @action removeMyImage = (data, cb) => {
    let property = ['id', 'store_id'];
    let variables = util.getDataStByKey(data, property);
    let params = {type: 'mutation', operation: 'removeMyImage', variables, getData: 'data'};
    const gpqParams = gql(params);
    return axios.post('/', gpqParams)
      .then(res => {
        const result = res.data.data[params.operation];
        if (typeof cb === 'function') cb(result); else return result;
      })
      .catch(err => { console.log(err); return err; });
  };

  @action removeMyImages = (data, cb) => {
    let property = ['ids', 'store_id'];
    let variables = util.getDataStByKey(data, property);
    let params = {type: 'mutation', operation: 'removeMyImages', variables, getData: 'data'};
    const gpqParams = gql(params);
    return axios.post('/', gpqParams)
      .then(res => {
        const result = res.data.data[params.operation];
        if (typeof cb === 'function') cb(result); else return result;
      })
      .catch(err => { console.log(err); return err; });
  };

  // === 배너 관리 ===
  @action getBannerList = (data, cb) => {
    let property = ['store_id', 'shopNo', 'page', 'limit', 'keyword', 'position', 'status'];
    let variables = util.getDataStByKey(data, property);
    let params = {type: 'query', operation: 'getBannerList', variables, getData: 'data'};
    const gpqParams = gql(params);
    return axios.post('/', gpqParams)
      .then(res => {
        const result = res.data.data[params.operation];
        if (typeof cb === 'function') cb(result); else return result;
      })
      .catch(err => { console.log(err); return err; });
  };

  @action getBanner = (data, cb) => {
    let property = ['id', 'store_id'];
    let variables = util.getDataStByKey(data, property);
    let params = {type: 'query', operation: 'getBanner', variables, getData: 'data'};
    const gpqParams = gql(params);
    return axios.post('/', gpqParams)
      .then(res => {
        const result = res.data.data[params.operation];
        if (typeof cb === 'function') cb(result); else return result;
      })
      .catch(err => { console.log(err); return err; });
  };

  @action saveBanner = (data, cb) => {
    let property = ['id', 'store_id', 'shopNo', 'data'];
    let variables = util.getDataStByKey(data, property);
    let params = {type: 'mutation', operation: 'saveBanner', variables, getData: 'data'};
    const gpqParams = gql(params);
    return axios.post('/', gpqParams)
      .then(res => {
        const result = res.data.data[params.operation];
        if (typeof cb === 'function') cb(result); else return result;
      })
      .catch(err => { console.log(err); return err; });
  };

  @action removeBanner = (data, cb) => {
    let property = ['id', 'store_id'];
    let variables = util.getDataStByKey(data, property);
    let params = {type: 'mutation', operation: 'removeBanner', variables, getData: 'data'};
    const gpqParams = gql(params);
    return axios.post('/', gpqParams)
      .then(res => {
        const result = res.data.data[params.operation];
        if (typeof cb === 'function') cb(result); else return result;
      })
      .catch(err => { console.log(err); return err; });
  };

  @action duplicateBanner = (data, cb) => {
    let property = ['id', 'store_id'];
    let variables = util.getDataStByKey(data, property);
    let params = {type: 'mutation', operation: 'duplicateBanner', variables, getData: 'data'};
    const gpqParams = gql(params);
    return axios.post('/', gpqParams)
      .then(res => {
        const result = res.data.data[params.operation];
        if (typeof cb === 'function') cb(result); else return result;
      })
      .catch(err => { console.log(err); return err; });
  };

  @action toggleBanner = (data, cb) => {
    let property = ['id', 'store_id', 'isActive'];
    let variables = util.getDataStByKey(data, property);
    let params = {type: 'mutation', operation: 'toggleBanner', variables, getData: 'data'};
    const gpqParams = gql(params);
    return axios.post('/', gpqParams)
      .then(res => {
        const result = res.data.data[params.operation];
        if (typeof cb === 'function') cb(result); else return result;
      })
      .catch(err => { console.log(err); return err; });
  };

  @action reorderBanners = (data, cb) => {
    let property = ['store_id', 'position', 'orderedIds'];
    let variables = util.getDataStByKey(data, property);
    let params = {type: 'mutation', operation: 'reorderBanners', variables, getData: 'data'};
    const gpqParams = gql(params);
    return axios.post('/', gpqParams)
      .then(res => {
        const result = res.data.data[params.operation];
        if (typeof cb === 'function') cb(result); else return result;
      })
      .catch(err => { console.log(err); return err; });
  };

  // === 팝업 관리 ===
  @action getPopupList = (data, cb) => {
    let property = ['store_id', 'shopNo', 'page', 'limit', 'keyword', 'position', 'status', 'type'];
    let variables = util.getDataStByKey(data, property);
    let params = {type: 'query', operation: 'getPopupList', variables, getData: 'data'};
    const gpqParams = gql(params);
    return axios.post('/', gpqParams)
      .then(res => {
        const result = res.data.data[params.operation];
        if (typeof cb === 'function') cb(result); else return result;
      })
      .catch(err => { console.log(err); return err; });
  };

  @action getPopup = (data, cb) => {
    let property = ['id', 'store_id'];
    let variables = util.getDataStByKey(data, property);
    let params = {type: 'query', operation: 'getPopup', variables, getData: 'data'};
    const gpqParams = gql(params);
    return axios.post('/', gpqParams)
      .then(res => {
        const result = res.data.data[params.operation];
        if (typeof cb === 'function') cb(result); else return result;
      })
      .catch(err => { console.log(err); return err; });
  };

  @action savePopup = (data, cb) => {
    let property = ['id', 'store_id', 'shopNo', 'data'];
    let variables = util.getDataStByKey(data, property);
    let params = {type: 'mutation', operation: 'savePopup', variables, getData: 'data'};
    const gpqParams = gql(params);
    return axios.post('/', gpqParams)
      .then(res => {
        const result = res.data.data[params.operation];
        if (typeof cb === 'function') cb(result); else return result;
      })
      .catch(err => { console.log(err); return err; });
  };

  @action removePopup = (data, cb) => {
    let property = ['id', 'store_id'];
    let variables = util.getDataStByKey(data, property);
    let params = {type: 'mutation', operation: 'removePopup', variables, getData: 'data'};
    const gpqParams = gql(params);
    return axios.post('/', gpqParams)
      .then(res => {
        const result = res.data.data[params.operation];
        if (typeof cb === 'function') cb(result); else return result;
      })
      .catch(err => { console.log(err); return err; });
  };

  @action duplicatePopup = (data, cb) => {
    let property = ['id', 'store_id'];
    let variables = util.getDataStByKey(data, property);
    let params = {type: 'mutation', operation: 'duplicatePopup', variables, getData: 'data'};
    const gpqParams = gql(params);
    return axios.post('/', gpqParams)
      .then(res => {
        const result = res.data.data[params.operation];
        if (typeof cb === 'function') cb(result); else return result;
      })
      .catch(err => { console.log(err); return err; });
  };

  @action togglePopup = (data, cb) => {
    let property = ['id', 'store_id', 'isActive'];
    let variables = util.getDataStByKey(data, property);
    let params = {type: 'mutation', operation: 'togglePopup', variables, getData: 'data'};
    const gpqParams = gql(params);
    return axios.post('/', gpqParams)
      .then(res => {
        const result = res.data.data[params.operation];
        if (typeof cb === 'function') cb(result); else return result;
      })
      .catch(err => { console.log(err); return err; });
  };

  @action reorderPopups = (data, cb) => {
    let property = ['store_id', 'orderedIds'];
    let variables = util.getDataStByKey(data, property);
    let params = {type: 'mutation', operation: 'reorderPopups', variables, getData: 'data'};
    const gpqParams = gql(params);
    return axios.post('/', gpqParams)
      .then(res => {
        const result = res.data.data[params.operation];
        if (typeof cb === 'function') cb(result); else return result;
      })
      .catch(err => { console.log(err); return err; });
  };

  @action fetchPageHtml = (url, cb) => {
    let params = {
      type: 'query',
      operation: 'fetchPageHtml',
      variables: { url: url },
      getData: 'dataString'
    };
    const gpqParams = gql(params);
    return axios.post('/', gpqParams)
      .then(function (res) {
        const result = res.data.data[params.operation];
        if (typeof cb === 'function') cb(result);
        else return result;
      })
      .catch(function (error) { console.log(error); return error; });
  };

  @action getDoc = (operation, param, cb ) => {
    let params = {
      type: 'query',
      operation: 'getDoc',
      variables: {operation: operation, param:param},
      getData: 'data'
    };
    const gpqParams = gql(params);

    return axios.post('/', gpqParams)
      .then(function (res) {
        let result = res.data.data[params.operation];

        if(typeof cb === 'function') {
          cb(result);
        }
        else {
          return result;
        }
      })
      .catch(function (error) {
        console.log(error);
        return error;
      });
  };

  @action getSnsConnections = (data, cb) => {

    let property = ['store_id', 'shopNo']
    let variables = util.getDataStByKey(data, property);

    let params = {
      type: 'query',
      operation: 'getSnsConnections',
      variables: variables,
      getData: 'data'
    };
    const gpqParams = gql(params);

    return axios.post('/', gpqParams)
        .then(function (res) {
          let result = res.data.data[params.operation];

          if(typeof cb === 'function') {
            cb(result);
          }
          else {
            return result;
          }
        })
        .catch(function (error) {
          console.log(error);
          return error;
        });
  };

  @action getInstagramFeed = (data, cb) => {

    let property = ['store_id', 'shopNo', 'platform', 'after']
    let variables = util.getDataStByKey(data, property);

    let params = {
      type: 'query',
      operation: 'getInstagramFeed',
      variables: variables,
      getData: 'data'
    };
    const gpqParams = gql(params);

    return axios.post('/', gpqParams)
        .then(function (res) {
          let result = res.data.data[params.operation];

          if(typeof cb === 'function') {
            cb(result);
          }
          else {
            return result;
          }
        })
        .catch(function (error) {
          console.log(error);
          return error;
        });
  };

  @action getInstagramTaggedFeed = (data, cb) => {

    let property = ['store_id', 'shopNo', 'after']
    let variables = util.getDataStByKey(data, property);

    let params = {
      type: 'query',
      operation: 'getInstagramTaggedFeed',
      variables: variables,
      getData: 'data'
    };
    const gpqParams = gql(params);

    return axios.post('/', gpqParams)
        .then(function (res) {
          let result = res.data.data[params.operation];

          if(typeof cb === 'function') {
            cb(result);
          }
          else {
            return result;
          }
        })
        .catch(function (error) {
          console.log(error);
          return error;
        });
  };

  @action disconnectSns = (data, cb) => {

    let property = ['store_id', 'shopNo']
    let variables = util.getDataStByKey(data, property);

    let params = {
      type: 'mutation',
      operation: 'disconnectSns',
      variables: variables,
      getData: 'data'
    };
    const gpqParams = gql(params);

    return axios.post('/', gpqParams)
        .then(function (res) {
          let result = res.data.data[params.operation];

          if(typeof cb === 'function') {
            cb(result.data);
          }
          else {
            return result.data;
          }
        })
        .catch(function (error) {
          console.log(error);
          if(typeof cb === 'function') {
            cb({success: false, message: error.message});
          }
          return error;
        });
  };

  @action finalizeFacebookPage = (data, cb) => {
    let property = ['store_id', 'shopNo', 'pageId'];
    let variables = util.getDataStByKey(data, property);

    let params = {
      type: 'mutation',
      operation: 'finalizeFacebookPage',
      variables: variables,
      getData: 'data'
    };
    const gpqParams = gql(params);

    return axios.post('/', gpqParams)
        .then(function (res) {
          let result = res.data.data[params.operation];
          if(typeof cb === 'function') {
            cb(result ? result.data : null, res.data.errors);
          }
          return result ? result.data : null;
        })
        .catch(function (error) {
          console.log(error);
          if(typeof cb === 'function') {
            cb(null, [{ message: error.message }]);
          }
          return error;
        });
  };

  @action uploadImages = (params, cb) => {

    return originAxiosInstance.post('/api/upload', params)
        .then(function (res) {
          let result = res.data;
          if(typeof cb === 'function') {
            cb(result);
          }
          else {
            return result;
          }

        })
        .catch(function (error) {
          if(typeof cb === 'function') {
            cb(error)
          }
          return error;
        });
  };

  @action cafe24UploadFiles = (data, cb) => {

    let property = ['store_id', 'imagesUrls']
    let variables = util.getDataStByKey(data, property);

    let params = {
      type: 'mutation',
      operation: 'cafe24UploadFiles',
      variables: variables,
      getData: 'data'
    };
    const gpqParams = gql(params);

    return axios.post('/', gpqParams)
        .then(function (res) {
          // GraphQL 최상위 에러
          if (res && res.data && Array.isArray(res.data.errors) && res.data.errors.length > 0) {
            const payload = { error: { code: 500, message: res.data.errors[0].message || 'GraphQL 오류' } };
            if (typeof cb === 'function') return cb(payload);
            return payload;
          }
          const result = res && res.data && res.data.data ? res.data.data[params.operation] : null;
          const payload = (result && result.data) ? result.data : { error: { code: 500, message: '카페24 업로드 응답이 비어 있습니다.' } };
          if (typeof cb === 'function') {
            cb(payload);
          } else {
            return payload;
          }
        })
        .catch(function (error) {
          const payload = { error: { code: 500, message: (error && error.message) ? error.message : '네트워크 오류' } };
          if (typeof cb === 'function') cb(payload);
          return payload;
        });
  };

  @action cafe24UploadImages = (data, cb) => {

    let property = ['store_id', 'imagesUrls']
    let variables = util.getDataStByKey(data, property);

    let params = {
      type: 'mutation',
      operation: 'cafe24UploadImages',
      variables: variables,
      getData: 'data'
    };
    const gpqParams = gql(params);

    return axios.post('/', gpqParams)
        .then(function (res) {
          let result = res.data.data[params.operation];
          if(typeof cb === 'function') {
            cb(result.data);
          }
          else {
            return result.data;
          }

        })
        .catch(function (error) {
          if(typeof cb === 'function') {
            cb(error)
          }
          return error;
        });
  };

  @action base64UploadImages = (data, cb) => {

    let property = ['store_id', 'base64Imgs']
    let variables = util.getDataStByKey(data, property);

    let params = {
      type: 'mutation',
      operation: 'base64UploadImages',
      variables: variables,
      getData: 'data'
    };
    const gpqParams = gql(params);

    return axios.post('/', gpqParams)
        .then(function (res) {
          if (res && res.data && Array.isArray(res.data.errors) && res.data.errors.length > 0) {
            const payload = { errors: res.data.errors };
            if (typeof cb === 'function') return cb(payload);
            return payload;
          }
          const result = res && res.data && res.data.data ? res.data.data[params.operation] : null;
          const payload = (result && result.data) ? result.data : null;
          if(typeof cb === 'function') {
            cb(payload);
          } else {
            return payload;
          }
        })
        .catch(function (error) {
          const payload = { errors: [{ message: (error && error.message) || '네트워크 오류' }] };
          if(typeof cb === 'function') cb(payload);
          return payload;
        });
  };

  @action updateDoc = (operation, param, cb ) => {


    let params = {
      type: 'mutation',
      operation: 'updateDoc',
      variables: {operation: operation, param:param},
      getData: 'data'
    };

    const gpqParams = gql(params);

    return axios.post('/', gpqParams)
      .then(function (res) {
        let result = res.data && res.data.data ? res.data.data[params.operation] : null;
        let errors = res.data && res.data.errors ? res.data.errors : null;
        if(typeof cb === 'function') {
          cb(result, errors);
        }
        else {
          return result;
        }
      })
      .catch(function (error) {
        console.log(error);
        return error;
      });
  };

  @action getDashBoardReport = (data, cb) => {

    let property = ['store_id', 'shopNo']
    let variables = util.getDataStByKey(data, property);

    let params = {
      type: 'query',
      operation: 'getDashBoardReport',
      variables: variables,
      getData: 'data'
    };
    const gpqParams = gql(params);

    return axios.post('/', gpqParams)
        .then(function (res) {
          let result = res.data.data[params.operation];
          if(typeof cb === 'function') {
            cb(result.data);
          }
          else {
            return result.data;
          }

        })
        .catch(function (error) {
          if(typeof cb === 'function') {
            cb(error)
          }
          return error;
        });
  };


  @action delDoc = (operation, param, cb ) => {

    let params = {
      type: 'mutation',
      operation: operation,
      variables: param,
      getData: 'data'
    };

    const gpqParams = gql(params);

    return axios.post('/', gpqParams)
      .then(function (res) {
        let result = res.data.data[params.operation];


        if(typeof cb === 'function') {
          cb(result);
        }
        else {
          return result;
        }
      })
      .catch(function (error) {
        console.log(error);
        return error;
      });
  };


  @action getCategory = (param, cb) => {

    let category = this.category;
    if(category.length > 0) {
      return category;
    }
    else {
      let params = {
        type: 'query',
        operation: 'getCategory',
        variables: param ? param : {},
        getData: 'id cls depth label order'
      };

      const gpqParams = gql(params);

      return axios.post('/', gpqParams)
        .then(function (res) {
          if(res.status === 200) {
            let row = {};
            let proc_1 = _.groupBy(res.data.data[params.operation], function(item){ return item.depth; });

            _.each(proc_1, function(data, index) {

              let proc_2;

              if(index === "1") {
                proc_2 = data;
              }
              else {
                proc_2 = _.groupBy(data, function(item){ return item.key });
              }
              row['depth_' + index] = proc_2;
              category = row;
            });
            if(typeof cb === 'function') {
              cb(category);
            }
            else {

              return proc_1;
            }
          }

        })
        .catch(function (error) {
          console.log(error);
          return error;
        });
    }

  };



  @action updateCategory = (param, cb) => {

    let params = {
      type: 'mutation',
      operation: 'updateCategory',
      variables: param,
      getData: 'data'
    };

    const gpqParams = gql(params);

    axios.post('/', gpqParams)
      .then(function (res) {
        let result = res.data.data[params.operation];


        if(typeof cb === 'function') {
          cb(result);
        }
        else {
          return result;
        }
      })
      .catch(function (error) {
        console.log(error);
        return error;
      });
  };

  @action updateCategoryOrder = (param, cb) => {

    let params = {
      type: 'mutation',
      operation: 'updateCategoryOrder',
      variables: param,
      getData: 'data'
    };

    const gpqParams = gql(params);

    axios.post('/', gpqParams)
      .then(function (res) {
        let result = res.data.data[params.operation];


        if(typeof cb === 'function') {
          cb(result);
        }
        else {
          return result;
        }
      })
      .catch(function (error) {
        console.log(error);
        return error;
      });
  };


  @action getUploadUrl = (mediaType, cb) => {

    let variables = {mediaType:mediaType};
    let params = {
      type: 'query',
      operation: 'getUploadUrl',
      variables: variables,
      getData: 'data'
    };

    const gpqParams = gql(params);

    axios.post('/', gpqParams)
      .then(function (res) {
        if(res.status === 200) {
          if(typeof cb === 'function') {
            if(!res.data.data[params.operation] || !res.data.data[params.operation].data || !res.data.data[params.operation].data.result || !res.data.data[params.operation].data.result.uploadURL) {
              console.log(res.data.data[params.operation]);
            }
            else {
              if(mediaType === 'video') {
                cb(res.data.data[params.operation].data.result)
              }
              else {
                cb(res.data.data[params.operation].data.result.uploadURL)
              }

            }

          }
          else {
            console.log(res.data.data[params.operation])
            //console.log(res.data.data[params.operation])
            //return res.data.data[params.operation];
          }
        }

      })
      .catch(function (error) {
        return error;
      });

  }

  @action uploadImg = (uploadUrl, file, cb) => {
    const formData = new FormData();
    formData.append("file", file.files[0]);
    axios.post(uploadUrl, formData )
      .then(function (res) {
        if(res.status === 200) {
          if(typeof cb === 'function') {
            cb(res.data.result)
          }
          else {
            return res.data.result;
          }
        }
      })
      .catch(function (error) {
        return error;
      });
  }

  @action removeMedia = (param, cb) => {
    let params = {
      type: 'query',
      operation: 'removeMedia',
      variables: param,
      getData: 'data'
    };

    const gpqParams = gql(params);

    return axios.post('/', gpqParams)
        .then(function (res) {
          let result = res.data.data[params.operation];
          if(typeof cb === 'function') {
            cb(result);
          }
          else {
            return result;
          }
        })
        .catch(function (error) {
          console.log(error);
          return error;
        });
  }


  @action sendMail = (param,cb) => {


    let params = {
      type: 'mutation',
      operation: 'sendMail',
      variables: param,
      getData: 'data'
    };

    const gpqParams = gql(params);

    return axios.post('/', gpqParams)
        .then(function (res) {
          let result = res.data.data[params.operation];
          if(typeof cb === 'function') {
            cb(result);
          }
          else {
            return result;
          }
        })
        .catch(function (error) {
          console.log(error);
          return error;
        });
  };

  @action testCafe24Api = (param,cb) => {


    let params = {
      type: 'mutation',
      operation: 'testCafe24Api',
      variables: param,
      getData: 'data'
    };

    const gpqParams = gql(params);

    return axios.post('/', gpqParams)
        .then(function (res) {
          let result = res.data.data[params.operation];
          if(typeof cb === 'function') {
            cb(result);
          }
          else {
            return result;
          }
        })
        .catch(function (error) {
          console.log(error);
          return error;
        });
  };


  @action getCollectionCount = (param, cb) => {
    let params = {
      type: 'query',
      operation: 'getCollectionCount',
      variables: param,
      getData: 'data'
    };

    const gpqParams = gql(params);

    return axios.post('/', gpqParams)
        .then(function (res) {
          let result = res.data.data[params.operation];
          if(typeof cb === 'function') {
            cb(result);
          }
          else {
            return result;
          }
        })
        .catch(function (error) {
          console.log(error);
          return error;
        });
  }

  @action getMsgList = (param, cb) => {
    let params = {
      type: 'query',
      operation: 'getMsgList',
      variables: param,
      getData: 'docs, totalDocs, limit, page, nextPage, prevPage, totalPages, pagingCounter, meta'
    };

    const gpqParams = gql(params);

    return axios.post('/', gpqParams)
        .then(function (res) {
          let result = res.data.data[params.operation];
          if(typeof cb === 'function') {
            cb(result);
          }
          else {
            return result;
          }
        })
        .catch(function (error) {
          console.log(error);
          return error;
        });
  }

  @action getMsgStats = (param, cb) => {
    let params = {
      type: 'query',
      operation: 'getMsgStats',
      variables: param,
      getData: 'data'
    };
    const gpqParams = gql(params);

    return axios.post('/', gpqParams)
      .then(function (res) {
        const result = res.data.data[params.operation];
        if (typeof cb === 'function') cb(result);
        else return result;
      })
      .catch(function (error) {
        console.log(error);
        if (typeof cb === 'function') cb(null);
        return error;
      });
  }



}
